import React from "react";
import './Footer.sass';


function Footer() {

  return (
    <footer className="footer text-center">
      <p className="m-0 p-3">Copyright © <span className="text-main-color">2022</span> GOSTO all rights reserved. Powered by <span className="text-main-color">AHMED ALI</span></p>
    </footer>
    
  );
}

export default Footer;
